import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-enable",
  "use": "icon-enable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-enable\"><defs><style type=\"text/css\"></style></defs><path d=\"M310.031079 82.077344c-7.4159-8.485255-18.295692-13.873985-30.467919-13.873985-8.886391 0-17.09126 2.89698-23.752983 7.736195-1.947352 1.36816-3.796466 2.868327-5.525853 4.611018-9.985422 9.999748-11.395538 22.074761-11.230786 36.83493l0 793.82876c-0.528026 12.06171 1.245364 26.824949 11.230786 36.836977 15.941064 16.019859 41.810245 16.019859 57.750285 0l525.992689-404.133294c8.151657-8.163937 12.116969-18.914792 11.95631-29.624714 0.160659-10.709923-3.806699-21.461801-11.95631-29.625738L310.031079 82.077344 310.031079 82.077344 310.031079 82.077344z\" p-id=\"1426\" fill=\"#1afa29\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/enable.svg
// module id = wMzE
// module chunks = 2